import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import './modules/register-service-worker';
import './components/navigation.ts';
import multiselect from './components/multiselect';
import contentFiltering from './modules/content-filtering';
import card from './components/card';
import './components/headerSearch.ts';
import Sidenav from './components/sidemenu.js';
import charts from './components/charts.js';
import basket from './modules/basket.ts';
import newsletter from './components/newsletter.js';
import addsearch from './modules/addsearch.ts';

branchBar.init();
card();
basket.init();
// addsearch.init();
// See https://www.npmjs.com/package/@crasman/branch-bar for settings
document.addEventListener('DOMContentLoaded', () => {
  const tryInit = (label, fn) => {
    try {
      fn();
    } catch (err) {
      console.error(`[${label}] init failed:`, err);
    }
  };

  tryInit('multiselect', () => multiselect.init());
  tryInit('contentFiltering', () => contentFiltering.init());
  tryInit('Sidenav', () => Sidenav.init());

  if (document.getElementById('chart-modal-template')) {
    tryInit('charts', () => charts.init());
  }

  tryInit('newsletter', () => newsletter.init());

  if (document.querySelector('.openai')) {
    import('./components/openai.js')
      .then(({ default: openai }) => openai())
      .catch((err) => console.error('[openai] init failed:', err));
  }
});
